import axios from "axios";
import { store } from "@/store/store";
import { Loading } from "quasar";
import router from "vue-router";
import { Feedback } from "@/utils/notify-toaster.js";
import { checkPermission } from "@/utils/permissions-validations.js";

const client = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_HOST,
  headers: {
    Accept: "application/json",
  },
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch("autoLogout");
      router.push("/login");
    }
    //check if error is 500 range
    if (error.response.status >= 500) {
      if (checkPermission("system_settings")) {
        Feedback.error(error.config.url + " :" + error.response.status);
      }
    }
    if (error.response.status >= 400 && error.response.status < 500) {
      if (checkPermission("system_settings")) {
        Feedback.error("Status " + error.response.status + ": " + error.response.data.error);
      }
    }
    return Promise.reject(error);
  }
);
var numberOfAjaxCAllPending = 0;
// var showingSpinner;

// // Add a request interceptor
// client.interceptors.request.use(function(config) {
//     numberOfAjaxCAllPending++;

//     if (!showingSpinner) {
//         Loading.show({
//             delay: 300,
//             spinner: QSpinnerIos,
//             spinnerColor: "blue-10",
//             backgroundColor: "blue-4",
//             message: "A carregar dados...",
//             messageColor: "black"
//         });
//         showingSpinner = true;
//     }

//     config.headers.Authorization = window.localStorage.getItem("jwtoken");

//     return config;
// }, function(error) {
//     return Promise.reject(error);
// });

client.interceptors.request.use(
  function (config) {
    //const token = window.localStorage.getItem("jwtoken");
    //Token chega ao frontend Ok, não é reutilizado aqui, não consigo fazer print.

    const token = store.getters.token;
    config.headers.Authorization = token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
client.interceptors.response.use(
  function (response) {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending === 0) {
      Loading.hide();
      // showingSpinner = false;
    }
    return response;
  },
  function (error) {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending === 0) {
      Loading.hide();
      // showingSpinner = false;
    }

    if (error.response.status === 401) {
      store.dispatch("autoLogout");
      router.push("/login");
    }

    return Promise.reject(error);
  }
);

const cacheClearPeriod = 1000;
const pendings = {};
const caches = {};
const cacheUtils = {
  getUniqueUrl: function (config) {
    let params = Object.keys(config.params)
      .map((key) => `${key}=${config.params[key]}`)
      .join("&");

    // you can set the rule based on your own requirement
    return `${config.url}${params}|${config.method}`;
  },
  isCached: function (config) {
    let uniqueUrl = this.getUniqueUrl(config);
    return caches[uniqueUrl] !== undefined;
  },
  isPending: function (config) {
    let uniqueUrl = this.getUniqueUrl(config);
    if (!pendings[uniqueUrl]) {
      pendings[uniqueUrl] = [config];
      return false;
    } else {
      pendings[uniqueUrl].push(config);
      return true;
    }
  },

  setCachedResponse: function (config, response) {
    let uniqueUrl = this.getUniqueUrl(config);
    caches[uniqueUrl] = response;
    if (pendings[uniqueUrl]) {
      pendings[uniqueUrl].forEach((configItem) => {
        configItem.isFinished = true;
      });
    }
  },

  getError: function (config) {
    const skipXHRError = new Error("skip");
    skipXHRError.isSkipXHR = true;
    skipXHRError.requestConfig = config;
    return skipXHRError;
  },

  getCachedResponse: function (config) {
    let uniqueUrl = this.getUniqueUrl(config);
    return caches[uniqueUrl];
  },
};
// This should be the *last* request interceptor to add
client.interceptors.request.use(function (config) {
  // to avoid careless bug, only the request that explicitly declares *canCache* parameter can use cache
  if (config.canCache) {
    if (cacheUtils.isCached(config)) {
      let error = cacheUtils.getError(config);
      throw error;
    }
    if (cacheUtils.isPending(config)) {
      return new Promise((resolve, reject) => {
        let interval = setInterval(() => {
          if (config.isFinished) {
            clearInterval(interval);
            let error = cacheUtils.getError(config);
            reject(error);
          }
        }, 200);
      });
    } else {
      // the head of cacheable requests queue, get the response by http request
      return config;
    }
  } else {
    return config;
  }
});
const clearCache = () => {
  Object.keys(caches).forEach((item) => delete caches[item]);
  Object.keys(pendings).forEach((item) => delete pendings[item]);
  setTimeout(clearCache, cacheClearPeriod);
};
setTimeout(clearCache, cacheClearPeriod);

export default {
  login: (email, password) => {
    var payload = {
      user: {
        email: email,
        password: password,
      },
    };

    return client.post("/auth/login", payload);
  },
  getUsersList: function (pagination = null) {
    let endpoint = "/users_list";
    let params = null;
    let query = [];

    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },
  // localhost:3000/roles
  getRolesList: function () {
    return client.get("/roles_list");
  },

  getAvailablePermissionsList: function () {
    return client.get("/permission_list");
  },
  manageUser: function (payload) {
    return client.post("/manage_users", payload);
  },

  createUser: function (payload) {
    return client.post("/create_user", payload);
  },
  blockUser: function (payload) {
    return client.post("/block_user", payload);
  },
  deleteUser: function (payload) {
    return client.post("/delete_user", payload);
  },
  managePermission: function (payload) {
    return client.post("/manage_permission", payload);
  },

  //PORTAL CREDENTIALS
  getCredentialsList: function () {
    return client.get("/portal_credentials");
  },
  createCredential: function (payload) {
    return client.post("/portal_credentials", payload);
  },
  manageCredential: function (payload) {
    //PATCH/PUT /portal_credentials/1
    return client.put("/portal_credentials/" + payload.id, payload);
  },
  deleteCredential: function (payload) {
    //DELETE /portal_credentials/1
    return client.delete("/portal_credentials/" + payload.id);
  },
  //////////////

  getNielsenAreas: function () {
    return client.get("/nielsen_areas");
  },

  getUserSettings: function () {
    return client.get(`/users`);
  },
  updateNielsenArea: function (payload) {
    return client.put(`/nielsen_areas/${payload.id}`, payload);
  },

  getTags: function (context) {
    return client.get(`/tags?context=${context}`);
  },

  getDepartments: function () {
    return client.get("/departments");
  },

  getMetrics: function () {
    return client.get("/metrics");
  },

  getLanguages: function () {
    return client.get("/languages");
  },

  saveUserSettings: function (userObject) {
    return client.post(`/user/update`, userObject);
  },

  changePassword: function (payload) {
    return client.post("/auth/password_update", payload);
  },

  resetPassword: function (payload) {
    return client.post("/auth/password_recover", payload);
  },

  getConfig: function (key) {
    return client.get(`/global_configurations/${key}`);
  },

  getAllowedStructureUploads: function () {
    return client.get(`/global_configurations/admin_allowed_structure_uploads`);
  },

  getNextDataBuilderSync: function () {
    return client.get("/scheduling/data_builder_next_sync");
  },

  dataBuilderSyncNow: function () {
    return client.put("/scheduling/data_builder_sync_now");
  },

  saveDatabuilderQuery: function (payload) {
    return client.post("/data_builder/save_query", payload);
  },

  getDatabuilderUserSavedQueries: function () {
    return client.get("/data_builder/user_queries");
  },

  getSavedQueryById: function (id) {
    return client.get(`/data_builder/query_by_id?id=${id}`);
  },

  getSavedQueryByToken: function (token) {
    return client.get(`/data_builder/query_by_token?token=${token}`);
  },

  deleteSavedQuery: function (id) {
    return client.delete(`/data_builder/delete_query?id=${id}`);
  },

  getAutoOrderSchedulings: function () {
    return client.get("/auto_order_schedules");
  },

  createAutoOrderScheduling: function (autoOrderScheduling) {
    return client.post("/auto_order_schedules", {
      auto_order_schedule: autoOrderScheduling,
    });
  },

  updateExistingAutoOrderScheduling: function (autoOrderScheduling) {
    let autoOrderSchedulingId = autoOrderScheduling.configuration.id;
    return client.put(`/auto_order_schedules/${autoOrderSchedulingId}`, {
      auto_order_schedule: autoOrderScheduling,
    });
  },

  deleteAutoOrderScheduling: function (autoOrderSchedulingId) {
    return client.delete(`/auto_order_schedules/${autoOrderSchedulingId}`);
  },

  getReasonCodes: function () {
    return client.get("/global_configurations/reason_codes");
  },

  deleteSellout: function (id, destroyEntities = false) {
    return client.delete(`/file_uploads/${id}`, {
      data: { destroy_entities: destroyEntities },
    });  
  },

  saveConfig: function (key, data) {
    return client.post(`/global_configurations/${key}/save`, { data: data });
  },

  getOSAConfigs: function () {
    return client.get("/osa_configurations");
  },

  getOSATimeScales: function () {
    return client.get("/osa_time_scales");
  },

  createOSAConfig: function (osaConfig) {
    return client.post("/osa_configurations", osaConfig);
  },

  updateExistingOSAConfig: function (osaConfig) {
    let osaConfigId = osaConfig.id;
    return client.put(`/osa_configurations/${osaConfigId}`, osaConfig);
  },

  getLatestUploads: function () {
    return client.get("/file_uploads/latest");
  },
  getDataBuilderStatus: function () {
    return client.get("/data_builder/status");
  },

  getFileUploadMessageTypes() {
    return client.get("/file_upload_message_types");
  },

  getFileUploadMappings: function (
    pagination = null,
    filters = null,
    sort = null
  ) {
    let endpoint = "/file_upload_mappings";
    let query = [];
    let params = null;
    let filterParams = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
      if(pagination.raw){
        params.raw = pagination.raw;
      } else {
        params.raw = false;
      }
    }
    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (sort) {
      query.push(sort.map((item) => `sort[]=${item}`).join("&"));
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  getFileUploadMappingFrequencies: function () {
    return client.get("file_upload_mappings/frequencies");
  },

  getMarketTypes: function () {
    return client.get("/market_types");
  },

  getStoreChannels: function () {
    return client.get("/store_channels");
  },

  getRetailers: function () {
    return client.get("/retailers");
  },

  getInsignias: function () {
    return client.get("/insignias");
  },

  getRetailersForFileUpload: function () {
    return client.get("/retailers?scope=file_upload");
  },

  getInsigniaByRetailer: function (retailerId) {
    if (retailerId == null) {
      return Promise.resolve({ data: [] });
    }
    return client.get(`/retailers/${retailerId}/insignias`);
  },

  getInsigniaByRetailerForFileUpload: function (retailerId) {
    return client.get(`/retailers/${retailerId}/insignias?scope=file_upload`);
  },

  getChainsByInsignia: function (insigniaId) {
    if (insigniaId == null) {
      return Promise.resolve({ data: [] });
    }
    return client.get(`/insignias/${insigniaId}/chains`);
  },

  getDistricts: function () {
    return client.get("/districts");
  },

  getCountiesByDistrict: function (districtId) {
    if (districtId == null) {
      return Promise.resolve({ data: [] });
    }
    return client.get(`/districts/${districtId}/counties`);
  },

  getBorroughsByCounty: function (countyId) {
    if (countyId == null) {
      return Promise.resolve({ data: [] });
    }
    return client.get(`/counties/${countyId}/borroughs`);
  },

  getDateFormatList: function () {
    return client.get("/date_formats");
  },

  getFileTypeList: function () {
    return client.get("/file_types");
  },

  getPeriodicityList: function () {
    return client.get("/file_upload_periodicities");
  },

  getStoreHierarchyLevels: function () {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      return client.get(`/hierarchy_types/${typeId}/hierarchy_levels`);
    });
  },

  createStoreHierarchyLevel: function (params) {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/`,
        params
      );
    });
  },

  updateStoreHierarchyLevels: function (params) {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.id}`,
        params
      );
    });
  },

  getStoreHierarchyLevelElements: function (levelId, parentId = null) {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      let url = `/hierarchy_types/${typeId}/hierarchy_levels/${levelId}/hierarchy_level_elements`;
      if (parentId) {
        url += `?parent_id=${parentId}`;
      }
      return client.get(url);
    });
  },

  getAllStoreHierarchyLevelElements: function () {
    return this.getStoreHierarchyLevels().then(async (response) => {
      let result = [];
      for (let item of response.data) {
        let response = null;
        response = await this.getStoreHierarchyLevelElements(item.id);
        let data = [];
        if (Array.isArray(response.data)) {
          data = response.data;
        }
        result = [...result, ...data];
      }
      return result;
    });
  },

  createStoreHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/`,
        params
      );
    });
  },

  updateStoreHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Loja").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/${params.id}`,
        params
      );
    });
  },

  getGeographyHierarchyLevels: function () {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.get(`/hierarchy_types/${typeId}/hierarchy_levels`);
    });
  },

  getGeographyHierarchyLevelElements: function (levelId, parentId = null) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      let url = `/hierarchy_types/${typeId}/hierarchy_levels/${levelId}/hierarchy_level_elements`;
      if (parentId) {
        url += `?parent_id=${parentId}`;
      }
      return client.get(url);
    });
  },

  getAllGeographyHierarchyLevelElements: async function () {
    return this.getGeographyHierarchyLevels().then(async (resp) => {
      let result = [];
      for (let item of resp.data) {
        let response = null;
        let data = [];
        response = await this.getGeographyHierarchyLevelElements(item.id);
        if (Array.isArray(response.data)) {
          data = response.data.map((element) => {
            let r = element;
            r.level = item;
            r.level.parent = resp.data
              .filter((i) => i.id === r.level.parent_id)
              .pop();
            r.parent = result.filter((i) => i.id === r.parent_id).pop();
            return r;
          });
        }
        result = [...result, ...data];
      }
      return result;
    });
  },

  createGeographyHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/`,
        params
      );
    });
  },

  updateGeographyHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/${params.id}`,
        params
      );
    });
  },

  deleteGeographyHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.delete(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/${params.id}`
      );
    });
  },

  createGeographyHierarchyLevel: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/`,
        params
      );
    });
  },

  updateGeographyHierarchyLevels: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.id}`,
        params
      );
    });
  },

  deleteGeographyHierarchyLevels: function (params) {
    return client.get("/hierarchy_types?name=Geográfico").then(({ data }) => {
      let typeId = data[0].id;
      return client.delete(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.id}`
      );
    });
  },

  // dates -> {"max_date": "2020-01-01","min_date": "2019-01-01"}; scheduled -> {isScheduled: bool, scheduledDateTime: "YYYY-MM-DD HH:mm"}
  syncDatabuilder: function (dates, scheduled) {
    if (!scheduled.isScheduled) {
      return client.post("/file_uploads/sync_databases", dates);
    } else {
      //TODO: scheduled databuilder sync request goes here
    }
  },

  getSalesforceHierarchyLevels: function () {
    return client.get("/hierarchy_types?name=Vendedor").then(({ data }) => {
      let typeId = data[0].id;
      return client.get(`/hierarchy_types/${typeId}/hierarchy_levels`);
    });
  },

  createSalesforceHierarchyLevel: function (params) {
    return client.get("/hierarchy_types?name=Vendedor").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/`,
        params
      );
    });
  },

  updateSalesforceHierarchyLevels: function (params) {
    return client.get("/hierarchy_types?name=Vendedor").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.id}`,
        params
      );
    });
  },

  getSalesforceHierarchyLevelElements: async function () {
    let types = await client.get("/hierarchy_types?name=Vendedor");
    let typeId = types.data[0].id;
    let levels = await client.get(
      `/hierarchy_types/${typeId}/hierarchy_levels`
    );
    let result = [];
    for (let level of levels.data) {
      let levelId = level.id;
      let elements = await await client.get(
        `/hierarchy_types/${typeId}/hierarchy_levels/${levelId}/hierarchy_level_elements`
      );
      result = result.concat(elements.data);
    }
    return { data: result };
  },

  getRootHierarchyLevelElement: function (elementId) {
    return client.get(`/hierarchy_level_elements/${elementId}/root`);
  },

  getAllHierarchiesById: function (levelId) {
    return client.get(
      `/hierarchy_level_elements?hierarchy_level_id=${levelId}`
    );
  },

  getHierarchiesDataBuilder: function (known_name) {
    return client.get(
      `/data_builder/hierarchy_level_elements?name=${known_name}`
    );
  },

  getWeigthMeasurementUnits: function () {
    return client.get(`/measurement_units?measuement_type=Peso`);
  },

  getVolumeMeasurementUnits: function () {
    return client.get(`/measurement_units?measuement_type=Volume`);
  },

  getFileUploadDataTypes: function () {
    return client.get(`/file_upload_data_types`);
  },

  getFileOrigins: function () {
    return client.get(`/file_origins`);
  },

  getFileUploadTypeList: function () {
    return client.get(`/file_upload_validation_types`);
  },

  getOsaConfigFields: function () {
    return client.get(`/fields?scope=osa_config`);
  },

  getFileUploadMessages: function (
    pagination = null,
    fileUploadId = null,
    fileUploadMessageTypeId = null
  ) {
    let endpoint = "/file_upload_messages";
    let query = [];
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (fileUploadId) {
      if (params === null) {
        params = {};
      }
      params.file_upload_id = fileUploadId;
    }
    if (fileUploadMessageTypeId) {
      if (params === null) {
        params = {};
      }
      params.file_upload_message_type_id = fileUploadMessageTypeId;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  getFileUploads: function (
    pagination = null,
    filters = null,
    originId = null,
    dateSearch = null
  ) {
    let endpoint = "/file_uploads";
    let query = [];
    let params = null;
    let filterParams = null;
    if (
      dateSearch != null &&
      (dateSearch.date != undefined || dateSearch.searchDateType != undefined)
    ) {
      query.push(`date=${dateSearch.date}`);
      query.push(`searchDateType=${dateSearch.searchDateType}`);
    }
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (originId) {
      if (params === null) {
        params = {};
      }
      params.origin_id = originId;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  uploadFile(data) {
    for (let i = 0; i < data.file.length; i++) {
      let fileData = new FormData();
      let file = data.file[i];
      fileData.append("file_upload[user_id]", data.userId);
      fileData.append("file_upload[file_upload_object]", file);
      fileData.append(
        "file_upload[file_upload_mapping_id]",
        data.file_upload_mapping_id
      );
      fileData.append("file_upload[reference_date]", data.reference_date);
      let postResult = client.post("/file_uploads", fileData, {
        contentType: "multipart/form-data",
      });
      if (i === data.file.length - 1) {
        return postResult;
      }
    }

    // let bodyFormData = new FormData();

    // for (let key in data) {
    //   if (data[key]) {
    //     if (key == "file") {
    //       for (let i = 0; i < data[key].length; i++) {
    //         bodyFormData.append(`file_upload[${key}]`, data[key][i]);
    //       }
    //     } else {
    //       bodyFormData.append(`file_upload[${key}]`, data[key]);
    //     }
    //   }
    // }
    // return client.post("/file_uploads", bodyFormData, {
    //   contentType: "multipart/form-data",
    // });
  },

  createProductHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/`,
        params
      );
    });
  },

  updateProductHierarchyLevelElement: function (params) {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.level_id}/hierarchy_level_elements/${params.id}`,
        params
      );
    });
  },

  getProductHierarchyLevels: function () {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      return client.get(`/hierarchy_types/${typeId}/hierarchy_levels`);
    });
  },

  createProductHierarchyLevel: function (params) {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      return client.post(
        `/hierarchy_types/${typeId}/hierarchy_levels/`,
        params
      );
    });
  },

  updateProductHierarchyLevels: function (params) {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      return client.put(
        `/hierarchy_types/${typeId}/hierarchy_levels/${params.id}`,
        params
      );
    });
  },

  getProductHierarchyLevelElements: function (levelId, parentId = null) {
    return client.get("/hierarchy_types?name=Produto").then(({ data }) => {
      let typeId = data[0].id;
      let url = `/hierarchy_types/${typeId}/hierarchy_levels/${levelId}/hierarchy_level_elements`;
      if (parentId) {
        url += `?parent_id=${parentId}`;
      }
      return client.get(url);
    });
  },

  getAllProductHierarchyLevelElements: function () {
    return this.getProductHierarchyLevels().then(async (resp) => {
      let result = [];
      for (let item of resp.data) {
        let response = null;
        let data = [];
        response = await this.getProductHierarchyLevelElements(item.id);
        if (Array.isArray(response.data)) {
          data = response.data.map((element) => {
            let r = element;
            r.level = item;
            r.level.parent = resp.data
              .filter((i) => i.id === r.level.parent_id)
              .pop();
            r.parent = result.filter((i) => i.id === r.parent_id).pop();
            return r;
          });
        }

        result = [...result, ...data];
      }

      return result;
    });
  },

  getProducts: function (
    pagination = null,
    filters = null,
    sort = null,
    summary = false,
    search = null
  ) {
    let endpoint = "/products";
    let query = [];
    let params = null;
    let filterParams = null;
    if (search != null) {
      query.push(`search=${search}`);
    }
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }

    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (sort) {
      query.push(sort.map((item) => `sort[]=${item}`).join("&"));
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query.push(`summary=${summary}`);
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  getPendingValidations: function (type, pagination = null) {
    let params = null;
    let query = [];
    params = {};
    params.type = type;
    if (pagination) {
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    return client.get(
      [`/pending_validations`, query].filter((a) => a).join("?")
    );
  },

  getPendingValidationsNotification: function () {
    return client.get(`/pending_validations/notifications`);
  },

  getRawProducts: function () {
    return client.get("/all_products");
  },

  getProduct(id) {
    return client.get(`/products/${id}`);
  },

  getStoreHierarchy(id) {
    return client.get(`/stores/show_hierarchy/${id}`);
  },

  getProductHierarchy(id) {
    return client.get(`/products/show_hierarchy/${id}`);
  },

  createNewProduct: function (product) {
    return client.post("/products", product);
  },

  updateExistingProduct: function (product) {
    return client.put(`/pending_validations/products`, product);
  },

  updateManagementProduct: function (product) {
    return client.put(`/products/${product.id}`, product);
  },

  createNewProductCode: function (product) {
    return client.post("/product_codes", product);
  },

  deleteProduct: function (product) {
    let productId = product.id;
    return client.delete(`/products/${productId}`);
  },

  deleteProductValidation: function (product) {
    let productId = product.product_id;
    return client.delete(`/products/${productId}/validations`);
  },

  deleteProductValidationExclude: function (product) {
    let productId = product.product_id;
    return client.delete(`/products/${productId}/exclude`);
  },

  deleteStoreValidation: function (store) {
    let storeId = store.store_id;
    return client.delete(`/stores/${storeId}/validations`);
  },

  deleteStoreValidationExclude: function (store) {
    let storeId = store.store_id;
    return client.delete(`/stores/${storeId}/exclude`);
  },

  getWarehouses: function (pagination = null, filters = null) {
    let endpoint = "/storage_facilities";
    let query = [];
    let params = null;
    let filterParams = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  createNewWarehouse: function (warehouse) {
    return client.post("/storage_facilities", warehouse);
  },

  updateExistingWarehouse: function (storageFacility) {
    let storageFacilityId = storageFacility.id;
    return client.put(
      `/storage_facilities/${storageFacilityId}`,
      storageFacility
    );
  },

  deleteWarehouse: function (warehouse) {
    let warehouseId = warehouse.id;
    return client.delete(`/warehouses/${warehouseId}`);
  },

  getRawEmployees: function () {
    return client.get("/all_employees");
  },

  getSalesforceEmployeeTypes: function () {
    return client.get("/employee_types");
  },

  getSalesforceRoutePeriods: function () {
    return client.get("/route_periods");
  },

  getSalesforceEmployees: function (
    pagination = null,
    search = null,
    active = false
  ) {
    let endpoint = "/employees";
    let query = [];
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (search) {
      if (!params) {
        params = {};
      }
      params.search = search;
    }
    if (active) {
      if (!params) {
        params = {};
      }
      params.active = active;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  createNewSalesforceEmployee: function (employee) {
    return client.post("/employees", employee);
  },

  updateExistingSalesforceEmployee: function (employee) {
    let employeeId = employee.id;
    return client.put(`/employees/${employeeId}`, employee);
  },

  deleteSalesforceEmployee: function (employee) {
    let employeeId = employee.id;
    return client.delete(`/employees/${employeeId}`);
  },

  getSalesforceTeams: function (pagination = null, search = null) {
    let endpoint = "/teams";
    let query = [];
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (search) {
      if (!params) {
        params = {};
      }
      params.search = search;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  createNewSalesforceTeam: function (team) {
    return client.post("/teams", team);
  },

  updateExistingSalesforceTeam: function (team) {
    let teamId = team.id;
    return client.put(`/teams/${teamId}`, team);
  },

  deleteSalesforceTeam: function (team) {
    let teamId = team.id;
    return client.delete(`/teams/${teamId}`);
  },

  getSalesforceRoutes: function (pagination = null, search = null) {
    let endpoint = "/routes";
    let query = [];
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (search) {
      if (!params) {
        params = {};
      }
      params.search = search;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  createNewSalesforceRoute: function (route) {
    return client.post("/routes", route);
  },

  updateExistingSalesforceRoute: function (route) {
    let routeId = route.id;
    return client.put(`/routes/${routeId}`, route);
  },

  deleteSalesforceRoute: function (route) {
    let routeId = route.id;
    return client.delete(`/routes/${routeId}`);
  },

  getStores: function (
    pagination = null,
    filters = null,
    summary = false,
    search = null
  ) {
    let endpoint = "/stores";
    let query = [];
    let params = null;
    let filterParams = null;
    if (search != null) {
      query.push(`search=${search}`);
    }

    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query.push(`summary=${summary}`);
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  getRawStores: function () {
    return client.get("/all_stores");
  },

  getStoreTypologies: function () {
    return client.get('/store_typology');
  },

  getStore(id) {
    return client.get(`/stores/${id}`);
  },

  createNewStore: function (store) {
    return client.post("/stores", store);
  },

  updateManagementStore: function (store) {
    return client.put(`/stores/${store.id}`, store);
  },

  updateExistingStore: function (store) {
    return client.put(`/pending_validations/stores`, store);
  },

  createNewStoreCode: function (store) {
    return client.post("/store_codes", store);
  },

  deleteStore: function (store) {
    let storeId = store.id;
    return client.delete(`/stores/${storeId}`);
  },

  getStorageTypes: function () {
    return client.get("/storage_types");
  },

  getFieldList: function () {
    return client.get("/fields");
  },

  getSalesFieldList: function () {
    return client.get("/fields/sales");
  },

  createNewMapping: function (fileMapping) {
    return client.post("/file_upload_mappings", fileMapping);
  },

  updateExistingMapping: function (fileMapping) {
    let mappingId = fileMapping.id;
    return client.put(`/file_upload_mappings/${mappingId}`, fileMapping);
  },

  // getAllCardexEntries: function (pagination = null, filters = null) {
  //   let query = [];
  //   let params = null;
  //   let filterParams = null;
  //   if (pagination) {
  //     params = {};
  //     params.page = pagination.page;
  //     params.page_size = pagination.rowsPerPage;
  //   }
  //   if (filters) {
  //     filterParams = {};
  //     Object.values(filters).forEach((filter) => {
  //       if (filter.include) {
  //         filterParams[filter.column_key] = filter.include.join(",");
  //       }
  //     });
  //   }
  //   if (params) {
  //     query.push(
  //       Object.keys(params)
  //         .map((key) => `${key}=${params[key]}`)
  //         .join("&")
  //     );
  //   }
  //   if (filterParams) {
  //     query.push(
  //       Object.keys(filterParams)
  //         .map((key) => `filter[${key}]=${filterParams[key]}`)
  //         .join("&")
  //     );
  //   }
  //   query = query.join("&");
  //   if (!query.length) {
  //     query = null;
  //   }
  //   return client.get(["/cardex_entries", query].filter((a) => a).join("?"));
  // },

  getAllCardexEntries: function (pagination = null, filter = null) {
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }

    if (filter) {
      if (!params) {
        params = {};
      }
      params.filter = filter;
    }
    let result = client.get("/cardex_entries", { params, canCache: false });
    return result;
  },

  createNewCardexEntry: function (cardexEntry) {
    return client.post("/cardex_entries", cardexEntry);
  },

  updateExistingCardexEntry: function (cardexEntry) {
    let cardexEntryId = cardexEntry.id;
    return client.put(`/cardex_entries/${cardexEntryId}`, cardexEntry);
  },

  updateAutoOrderItem: function (item) {
    let itemId = item.id;
    return client.put(`/auto_orders/${itemId}`, item);
  },

  getAutoOrderFacilitatorItems: function (pagination = null, filters = null) {
    let endpoint = "/auto_order_supplier_recomendations";
    let query = [];
    let params = null;
    let filterParams = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (filters) {
      filterParams = {};
      Object.values(filters).forEach((filter) => {
        if (filter.include) {
          filterParams[filter.column_key] = filter.include.join(",");
        }
      });
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }
    if (filterParams) {
      query.push(
        Object.keys(filterParams)
          .map((key) => `filter[${key}]=${filterParams[key]}`)
          .join("&")
      );
    }
    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },

  updateAutoOrderFacilitatorItems: function (itemList) {
    return client.post(
      `/auto_order_supplier_recomendation/bulk_save`,
      itemList
    );
  },

  getReasonCodeList() {
    return client.get("/reason_codes");
  },

  getPhantomStockItems: function (pagination = null, filter = null) {
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }

    if (filter) {
      if (!params) {
        params = {};
      }
      params.filter = filter;
    }

    let result = client.get("/ghost_stocks", { params, canCache: false });
    return result;
  },

  updatePhantomStockItem: function (item) {
    let itemId = item.id;
    return client.put(`/ghost_stocks/${itemId}`, item);
  },
  fileUploadDownloadRequest: function (fileUploadId) {
    let params = { file_upload_id: fileUploadId };
    return client({
      method: "post",
      url: "/file_uploads/download",
      data: params,
      responseType: "blob",
    });
  },

  downloadRtlAutoOrderCsv: function (filters) {
    let body = filters ? { filters: filters } : null;
    return client({
      method: "post",
      url: "/auto_orders/rtl_export",
      data: body,
      responseType: "blob",
    });
  },

  downloadEmployeeList: function (search) {
    let body = search ? { search: search } : null;
    return client({
      method: "post",
      url: "/employees/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadTeamList: function (search) {
    let body = search ? { search: search } : null;
    return client({
      method: "post",
      url: "/teams/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadRouteList: function (search) {
    let body = search ? { search: search } : null;
    return client({
      method: "post",
      url: "/routes/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadAutoOrderExport: function (filters) {
    let body = filters ? filters : null;
    return client({
      method: "post",
      url: "/auto_orders/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadAutoOrderSupRec: function () {
    return client({
      method: "get",
      url: "/auto_order_supplier_recomendations/export",
      responseType: "blob",
    });
  },

  downloadProductPacks: function () {
    return client({
      method: "get",
      url: "/product_packs/export",
      responseType: "blob",
    });
  },

  downloadPackFeatureAssoc: function () {
    return client({
      method: "get",
      url: "/pack_feature_associations/export",
      responseType: "blob",
    });
  },

  getAutoOrderItems: function (pagination = null, filter = null) {
    let params = null;
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }

    if (filter) {
      if (!params) {
        params = {};
      }
      params.filter = filter;
    }
    let result = client.get("/auto_orders", { params, canCache: false });
    return result;
  },

  downloadProductList: function (filters) {
    let body = filters ? { filters: filters } : null;
    return client({
      method: "post",
      url: "/products/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadPendingValidationsList: function (type) {
    let body = { type: type };
    return client({
      method: "post",
      url: "/pending_validations/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadFileUploadsList: function (filters) {
    let body = filters ? { filters: filters } : null;
    return client({
      method: "post",
      url: "/file_uploads/export",
      data: body,
      responseType: "blob",
    });
  },

  massFileUploadDownload: function (requestData) {
    return client({
      method: "post",
      url: "/file_uploads/mass_export",
      data: requestData,
      responseType: "blob",
    });

  },

  downloadStoreList: function (filters) {
    let body = filters ? { filters: filters } : null;
    return client({
      method: "post",
      url: "/stores/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadWarehouseList: function (filters) {
    let body = filters ? { filters: filters } : null;
    return client({
      method: "post",
      url: "/storage_facilities/export",
      data: body,
      responseType: "blob",
    });
  },

  downloadCardexList: function (filters) {
    let params = {};
    if (filters) {
      params.filter = filters;
    }

    return client({
      method: "post",
      url: "/cardex_entries/export",
      data: params,
      responseType: "blob",
    });
  },

  downloadGhostStocks: function (filters) {
    let params = {};
    if (filters) {
      params.filter = filters;
    }

    return client({
      method: "post",
      url: "/ghost_stocks/export",
      data: params,
      responseType: "blob",
    });
  },
  downloadDaysWithoutSales: function (
    date,
    period,
    productHierarchyElementId,
    storeHierarchyElementId,
    geoHierarchyElementId,
    productId,
    storeId,
    employeeId,
    retailerId,
    customFilters,
    page,
    rowsPerPage
  ) {
    let processed_date = date.format("YYYY-MM-DD");
    let params = {
      date: processed_date,
      period: period,
      product_hierarchy_id: productHierarchyElementId,
      store_hierarchy_id: storeHierarchyElementId,
      geo_hierarchy_id: geoHierarchyElementId,
      product_id: productId,
      store_id: storeId,
      employee_id: employeeId,
      retailer_id: retailerId,
      page: page,
      page_size: rowsPerPage,
      download: true,
    };
    Object.keys(customFilters).forEach((key) => {
      if (customFilters[key]) {
        params[key] = customFilters[key];
      }
    });
    return client("/kpis/download_field_stocks_dws", { params, canCache: true });
  },

  kpis: {
    getStocksDaysWithoutSales: function (
      date,
      period,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      customFilters,
      page,
      rowsPerPage,
    ) {
      let processed_date = date.format("YYYY-MM-DD");
      let params = {
        date: processed_date,
        period: period,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
        download: false,
      };
      Object.keys(customFilters).forEach((key) => {
        if (customFilters[key]) {
          params[key] = customFilters[key];
        }
      });
      return client("/kpis/field_stocks_dws", { params, canCache: true });
    },

    getStocksAndSalesByDay: function (
      week,
      year,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage
    ) {
      let params = {
        week: week,
        year: year,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/stocks_sales_week", { params, canCache: true });
    },

    getFlashReportStoreRanking: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productId,
      storeId,
      employeeId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/flash_report_stores", { params, canCache: true });
    },

    getFlashReportProductRanking: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productId,
      storeId,
      employeeId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/flash_report_products", { params, canCache: true });
    },

    getSalesByPeriod: function (
      dateAggreg,
      year,
      month,
      day,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      retailerId,
      employeeId,
      current_year = false
    ) {
      let params = {
        date_aggreg: dateAggreg,
        ref_date_year: year,
        ref_date_month: month,
        ref_date_day: day,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        retailer_id: retailerId,
        field_id: fieldId,
        employee_id: employeeId,
        current_year: current_year,
      };
      return client("/kpis/aggregated_sales", { params, canCache: true });
    },

    getSalesByMonthForYear: function (
      year,
      month,
      day,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      fieldId,
      employeeId,
      retailerId
    ) {
      let params = {
        date_aggreg: "month",
        ref_date_year: year,
        ref_date_month: month,
        ref_date_day: day,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        retailer_id: retailerId,
        field_id: fieldId,
        employee_id: employeeId,
      };
      return client("/kpis/aggregated_sales", { params, canCache: true });
    },

    getStoreSalesOnPeriod: function (
      startDate,
      endDate,
      fieldId,
      storeNumber,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        limit: storeNumber,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/sales_by_store", { params, canCache: true });
    },

    getProductAbcCurve: function (
      startDate,
      endDate,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      limit,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        limit: limit,
        retailer_id: retailerId,
      };
      return client("/kpis/product_accumulated", { params, canCache: true });
    },

    getHierarchyLevelAbcCurve: function (
      startDate,
      endDate,
      fieldId,
      hierarchyLevelId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      limit,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        level_id: hierarchyLevelId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        limit: limit,
        retailer_id: retailerId,
      };
      return client("/kpis/product_aggregation", { params, canCache: true });
    },

    getSalesNumericDistribution: function (
      startDate,
      endDate,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/sales_numeric_distribution", {
        params,
        canCache: true,
      });
    },

    getSalesPonderatedDistribution: function (
      startDate,
      endDate,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/ponderated_distribution_sales", {
        params,
        canCache: true,
      });
    },

    getOutOfStockNumericDistribution: function (
      startDate,
      endDate,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/out_stock_distribution", { params, canCache: true });
    },

    getAverageMonthlySales: function (
      date,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/avg_month_sales_cy", { params, canCache: true });
    },

    getYearToDate: function (
      date,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/year_to_date", { params, canCache: true });
    },

    getMonthToDate: function (
      date,
      fieldId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        field_id: fieldId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/month_to_date", { params, canCache: true });
    },

    getChildrenAggregationByHierarchyElement: function (
      startDate,
      endDate,
      fieldId,
      hierarchyId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        hierarchy_id: hierarchyId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/product_aggregation_dashboard", {
        params,
        canCache: true,
      });
    },

    getChildrenAggregationByHierarchyStore: function (
      startDate,
      endDate,
      fieldId,
      hierarchyId,
      parentId,
      productHierarchyId,
      geoHierarchyId,
      productId,
      storeId,
      retailerId,
      employeeId,
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        hierarchy_id: hierarchyId,
        store_hierarchy_id: parentId,
        product_hierarchy_id: productHierarchyId,
        geo_hierarchy_id: geoHierarchyId,
        product_id: productId,
        store_id: storeId,
        retailer_id: retailerId,
        employee_id: employeeId,
      };
      return client("/kpis/store_aggregation", { params, canCache: true });
    },

    getSalesStocksComparison: function (
      date,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/kpi_stock_sales_coverage", {
        params,
        canCache: true,
      });
    },

    getDaysWithoutSales: function (
      startDate,
      endDate,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/days_without_sales", { params, canCache: true });
    },

    getDaysWithoutStocks: function (
      startDate,
      endDate,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
      };
      return client("/kpis/days_without_stocks", { params, canCache: true });
    },

    getOutOfStockProducts: function (
      startDate,
      endDate,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/out_of_stock", { params, canCache: true });
    },

    downloadOutOfStockProducts: function (
      startDate,
      endDate,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
        export: true
      };
      return client("/kpis/out_of_stock", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },

    getOverstockingProducts: function (
      startDate,
      endDate,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        threshold: 30,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/overstocking", { params, canCache: true });
    },

    downloadOverstockingProducts: function (
      startDate,
      endDate,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        threshold: 30,
        page: page,
        page_size: rowsPerPage,
        export: true
      };
      return client("/kpis/overstocking", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },

    getCardexForDate: function (
      date,
      status,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage,
      exportFlag = false
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        status: status,
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
        export: exportFlag
      };
      return client("/kpis/cardex", { params, canCache: true });
    },
    ExportCardexForDate: function (
      date,
      status,
      productHierarchyLevelId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      employeeId,
      retailerId,
      page,
      rowsPerPage,
      exportFlag = true
    ) {
      let params = {
        date: date.format("YYYY-MM-DD"),
        status: status,
        product_hierarchy_id: productHierarchyLevelId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
        export: exportFlag
      };
      return client("/kpis/cardex", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },
    getStoreList: function (
      startDate,
      endDate,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      routeId,
      employeeId,
      fieldId,
      retailerId,
      page,
      rowsPerPage,
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        field_id: fieldId,
        route_id: routeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
      };
      return client("/kpis/store_ranking", { params, canCache: true });
    },
    downloadStoreList: function (
      startDate,
      endDate,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      productId,
      storeId,
      routeId,
      employeeId,
      fieldId,
      retailerId,
      page,
      rowsPerPage,
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        product_id: productId,
        store_id: storeId,
        field_id: fieldId,
        route_id: routeId,
        employee_id: employeeId,
        retailer_id: retailerId,
        page: page,
        page_size: rowsPerPage,
        export: true
      };
      return client("/kpis/store_ranking", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },
    getFlashReportStoreRankingExport: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productId,
      storeId,
      employeeId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      page,
      rowsPerPage,
      exportOpt = "false"
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId,
        product_id: productId,
        store_id: storeId,
        employee_id: employeeId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        page: page,
        page_size: rowsPerPage,
        export: exportOpt,
      };
      return client("/kpis/flash_report_stores", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },
    getFlashReportProductRankingExport: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productId,
      storeId,
      employeeId,
      productHierarchyElementId,
      storeHierarchyElementId,
      geoHierarchyElementId,
      page,
      rowsPerPage,
      exportOpt = "false"
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId,
        product_id: productId,
        store_id: storeId,
        product_hierarchy_id: productHierarchyElementId,
        store_hierarchy_id: storeHierarchyElementId,
        geo_hierarchy_id: geoHierarchyElementId,
        employee_id: employeeId,
        page: page,
        page_size: rowsPerPage,
        export: exportOpt,
      };
      return client("/kpis/flash_report_products", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },

    getDnDpTableExport: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productLevelId,
      producthierarchyId,
      geoHierarchyId,
      employeeIds,
      page,
      pageSize,
      exportOpt = "false"
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId,
        product_level_id: productLevelId,
        product_hierarchy_id: producthierarchyId,
        geo_hierarchy_id: geoHierarchyId,
        employee_id: employeeIds,
        page: page,
        page_size: pageSize,
        export: exportOpt,
      };
      return client("/kpis/dp_dn_table", {
        params,
        canCache: true,
        responseType: "blob",
      });
    },

    getDnDpTable: function (
      startDate,
      endDate,
      fieldId,
      retailerId,
      productLevelId,
      producthierarchyId,
      geoHierarchyId,
      employeeIds,
      page,
      pageSize
    ) {
      let params = {
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        field_id: fieldId,
        retailer_id: retailerId ? retailerId : null,
        product_level_id: productLevelId ? productLevelId : null,
        product_hierarchy_id: producthierarchyId ? producthierarchyId : null,
        geo_hierarchy_id: geoHierarchyId ? geoHierarchyId : null,
        employee_id: employeeIds,
        page: page,
        page_size: pageSize,
      };

      return client("/kpis/dp_dn_table", { params, canCache: true });
    },

    getProductDistribution: function (
      type,
      dateAggreg,
      productId,
      productHierarchyId,
      geoHierarchyIds,
      fieldId,
      year,
      retailerId,
      employeeIds
    ) {
      let params = {
        type,
        date_aggreg: dateAggreg,
        product_id: productId,
        product_hierarchy_id: productHierarchyId,
        geo_hierarchy_id: geoHierarchyIds,
        field_id: fieldId,
        year: year,
        retailer_id: retailerId,
        employee_id: employeeIds
      };

      return client("/kpis/product_distribution", { params, canCache: true });
    },
  },
  getSchedulings: function (pagination = null) {
    let params = null;
    let endpoint = "/schedulings";
    let query = [];
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }

    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },
  getSchedulingPublishers: function () {
    return client.get("/scheduling_publishers");
  },
  schedulingHistoryFileDownloadRequest: function (history_id) {
    let params = { scheduling_history_id: history_id };
    return client({
      method: "post",
      url: "/scheduling_histories/download",
      data: params,
      responseType: "blob",
    });
  },
  getSchedulingHistoryElement: function (id) {
    return client.get("/scheduling_histories/"+id);
  },
  getSchedulingHistory: function (pagination = null) {
    let params = null;
    let endpoint = "/scheduling_histories";
    let query = [];
    if (pagination) {
      params = {};
      params.page = pagination.page;
      params.page_size = pagination.rowsPerPage;
    }
    if (params) {
      query.push(
        Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&")
      );
    }

    query = query.join("&");
    if (!query.length) {
      query = null;
    }
    return client.get([endpoint, query].filter((a) => a).join("?"));
  },
  createNewScheduling: function (scheduling) {
    return client.post("/schedulings", scheduling);
  },
  updateExistingScheduling: function (scheduling) {
    let schedulingId = scheduling.id;
    return client.put(`/schedulings/${schedulingId}`, scheduling);
  },
  deleteScheduling: function (scheduling) {
    let schedulingId = scheduling.id;
    return client.delete(`/schedulings/${schedulingId}`);
  },
  getPivotFields: function () {
    var endpoint = client("/data_builder/quest_tables");
    return endpoint;
  },
  postPivotDataRequest: function (json) {
    return client.put("/data_builder/data_quest", { json });
  },

  logout: function () {
    return client.delete("/auth/logout");
  },
};
